/**
 * 监听窗口宽度断点：lg(>=1024)、mdToLg(768–1024)
 * 抽离自 MusicPlayer.js
 */
import { useState, useEffect } from 'react';

/**
 * @returns {{ isLgUp: boolean, isMdToLg: boolean }}
 */
export function useBreakpoint() {
  const [isLgUp, setIsLgUp] = useState(() => {
    try { return typeof window !== 'undefined' ? window.innerWidth >= 1024 : true; } catch (_) { return true; }
  });
  const [isMdToLg, setIsMdToLg] = useState(() => {
    try {
      const w = typeof window !== 'undefined' ? window.innerWidth : 1200;
      return w >= 768 && w < 1024;
    } catch (_) {
      return false;
    }
  });

  useEffect(() => {
    let rafId = 0;
    const update = () => {
      const w = window.innerWidth || 0;
      const nextLg = w >= 1024;
      const nextMdToLg = w >= 768 && w < 1024;
      setIsLgUp(prev => (prev === nextLg ? prev : nextLg));
      setIsMdToLg(prev => (prev === nextMdToLg ? prev : nextMdToLg));
    };
    const schedule = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        update();
      });
    };
    schedule();
    window.addEventListener('resize', schedule);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('resize', schedule);
    };
  }, []);

  return { isLgUp, isMdToLg };
}
